import { createFileRoute } from "@tanstack/react-router";
import { redirectTo } from "@/lib/route-redirect";
export const Route = createFileRoute("/hosting/dedicated-server")({ beforeLoad: redirectTo("/hosting/dedicated-servers") });
